module.exports = __webpack_public_path__ + "static/media/supsi.aee29aa3.png";